<template>
  <el-container class="prelogin-container">
    <el-image
      :src="require('@/assets/images/background_preLogin.png')"
      class="prelogin-container__background-img"
    />
    <el-main class="prelogin-main">
      <router-view />
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'PreLogin',
  };
</script>

<style lang="scss">
  .prelogin-container {
    position: relative;
    height: 100vh;
    overflow-x: hidden;

    &__background-img.el-image {
      position: absolute;
      bottom: 0;

      .el-image__inner {
        width: auto;
        height: 100%;
      }
    }
  }
</style>
